import { Input as InputAntd } from 'antd';
import { InputProps } from 'antd/lib/input/Input';

import React, { CSSProperties } from 'react';

import styles from './Input.module.scss';


interface InternalProps extends Omit<InputProps, 'style'> {
  style?: CSSProperties | string;
}

const Input = ({style, ...props}:InternalProps) => {
  switch (props.type) {
    case 'password':
      return <InputAntd.Password {...props} className={styles.main}/>;
    default:
      return <InputAntd {...props} className={`${styles.main} ${style}`}/>
  }
}

export default Input;